import { render, staticRenderFns } from "./MedicalDevicesControl.vue?vue&type=template&id=b1b4d834"
import script from "./MedicalDevicesControl.vue?vue&type=script&lang=js"
export * from "./MedicalDevicesControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports